var map = {
	".": 143,
	"./": 143,
	"./Actions/Auth": 20,
	"./Actions/Auth.js": 20,
	"./Actions/EventsAndExperiences": 81,
	"./Actions/EventsAndExperiences.js": 81,
	"./Actions/Messages": 93,
	"./Actions/Messages.js": 93,
	"./Actions/Types": 16,
	"./Actions/Types.js": 16,
	"./Actions/WineLists": 26,
	"./Actions/WineLists.js": 26,
	"./App": 137,
	"./App.css": 61,
	"./App.js": 137,
	"./App.test": 437,
	"./App.test.js": 437,
	"./App2": 1032,
	"./Components/Common/PrivateRoute": 212,
	"./Components/Common/PrivateRoute.js": 212,
	"./Components/DashboardComponents": 31,
	"./Components/DashboardComponents.js": 31,
	"./Components/Jumbotron": 210,
	"./Components/Jumbotron.js": 210,
	"./Components/RatingsAndReviews": 96,
	"./Components/RatingsAndReviews.js": 96,
	"./Forms/CookieConsent": 217,
	"./Forms/CookieConsent.js": 217,
	"./Forms/FormComponents": 4,
	"./Forms/FormComponents.js": 4,
	"./Forms/Forms": 138,
	"./Forms/Forms.js": 138,
	"./Hooks/useConfirmSignUpModal": 85,
	"./Hooks/useConfirmSignUpModal.js": 85,
	"./Hooks/useFormErrorModal": 114,
	"./Hooks/useFormErrorModal.js": 114,
	"./Hooks/useJournalPostToDisplay": 216,
	"./Hooks/useJournalPostToDisplay.js": 216,
	"./Journal/Journal": 141,
	"./Journal/Journal.js": 141,
	"./Pages/Cart": 172,
	"./Pages/Cart.js": 172,
	"./Pages/Events": 36,
	"./Pages/Events.js": 36,
	"./Pages/Experiences": 41,
	"./Pages/Experiences.js": 41,
	"./Pages/Footer": 205,
	"./Pages/Footer.js": 205,
	"./Pages/Login": 211,
	"./Pages/Login.js": 211,
	"./Pages/Mydashboard": 214,
	"./Pages/Mydashboard.js": 214,
	"./Pages/Navigation": 206,
	"./Pages/Navigation.js": 206,
	"./Pages/NewsFeed": 231,
	"./Pages/NewsFeed.js": 231,
	"./Pages/PrivacyPolicy": 215,
	"./Pages/PrivacyPolicy.js": 215,
	"./Pages/Profile": 74,
	"./Pages/Profile.js": 74,
	"./Pages/Register": 213,
	"./Pages/Register.js": 213,
	"./Pages/SideNavigation": 94,
	"./Pages/SideNavigation.js": 94,
	"./Pages/WineLists": 68,
	"./Pages/WineLists.js": 68,
	"./Store": 17,
	"./Store.js": 17,
	"./Styles/Authentication.css": 229,
	"./Styles/Cart.css": 396,
	"./Styles/CookieConsent.css": 402,
	"./Styles/Events.css": 390,
	"./Styles/Footer.css": 309,
	"./Styles/Forms.css": 310,
	"./Styles/Journal.css": 230,
	"./Styles/Jumbotron.css": 320,
	"./Styles/JumbotronOriginal": 1033,
	"./Styles/MyDashboard.css": 185,
	"./Styles/MyDashboard_datepicker.css": 248,
	"./Styles/Navigation.css": 228,
	"./Styles/NewsFeed.css": 324,
	"./Styles/PrivacyPolicy.css": 399,
	"./Styles/RatingsAndReviews.css": 392,
	"./Styles/Reviews.css": 391,
	"./Styles/Shop.css": 232,
	"./Styles/SideNavigation.css": 397,
	"./Styles/SocialMediaLinks.css": 227,
	"./Styles/Testimonials.css": 401,
	"./Styles/WineLists.css": 398,
	"./img/blog/avignon_bridge_rhone_1600x1600.jpg": 1034,
	"./img/blog/paquay-summer-tasting-1600x1600.jpg": 1035,
	"./img/blog/spain_jerez_tapas_1600x1596.jpg": 1036,
	"./img/blog/troyes-champagne-lunchtime-1600x1067.jpg": 1037,
	"./img/blog/troyes-champagne-lunchtime-1600x1600.jpg": 1038,
	"./img/events/darjeeling-biryani-800x533.jpg": 393,
	"./img/jumbotron/tuscany_1600x1062.jpg": 296,
	"./img/jumbotron/wine-toast-1000x1000.jpg": 294,
	"./img/jumbotron/wine-toast-1600x1067.jpg": 1039,
	"./img/jumbotron/wine_tasting_1600x1600.jpg": 299,
	"./img/jumbotron/young-lady-in-vineyards_1600x1600.jpg": 300,
	"./img/logo/CARDS.svg": 298,
	"./img/logo/TTA_Financial_Protection_150x82.png": 295,
	"./img/logo/american-express-1.svg": 1040,
	"./img/logo/mastercard-2.svg": 1041,
	"./img/logo/visa-4.svg": 1042,
	"./img/pages/professionals/events/no-event-image-placeholder-2x.png": 1043,
	"./index": 143,
	"./index.css": 307,
	"./index.js": 143,
	"./logo.svg": 308,
	"./media/TTA_Financial_Protection_150x82.png": 1044,
	"./reducers": 136,
	"./reducers/": 136,
	"./reducers/auth": 207,
	"./reducers/auth.js": 207,
	"./reducers/eventsandexperiences": 209,
	"./reducers/eventsandexperiences.js": 209,
	"./reducers/index": 136,
	"./reducers/index.js": 136,
	"./reducers/winelist": 208,
	"./reducers/winelist.js": 208,
	"./serviceWorker": 218,
	"./serviceWorker.js": 218,
	"./setupTests": 480,
	"./setupTests.js": 480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;